import React from 'react';
import ExploreCard from './ExploreCard';
import { ReactComponent as NavForwardIcon } from '../../../Icons/nav-forward.svg';
import { calculateCourseCost, getCookbookCost } from '../../../config/contentPricingConfig';
import './ExploreGrid.css';

const ExploreGrid = ({
  templates,
  language,
  onCardClick,
  onViewDetails,
  isTemplateOwned,
  getCategoryDisplayName
}) => {
  if (!templates || templates.length === 0) {
    return (
      <div className="explore-grid-empty">
        <p>No templates available</p>
      </div>
    );
  }

  return (
    <div className="explore-grid-container">
      <div className="explore-grid">
        {templates.map((template, index) => {
          // Use tokenCost from catalog item if available, otherwise calculate
          const cost = template.isCatalogItem && template.tokenCost !== undefined
            ? template.tokenCost
            : template.type === 'cookbook'
              ? getCookbookCost(false)
              : calculateCourseCost('beginner'); // Default to beginner cost

          const isOwned = isTemplateOwned ? isTemplateOwned(template) : false;

          const rightContent = isOwned ? (
            <div className="explore-grid-card-owned-indicator" title="You already own this">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
          ) : (
            <div className="explore-grid-card-price">
              <span className="explore-grid-card-price-amount">{cost}</span>
              <span className="explore-grid-card-price-label">tokens</span>
            </div>
          );

          const actions = [
            {
              icon: (
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              ),
              onClick: () => onCardClick(template),
              className: 'explore-grid-card-action-icon--preview',
              ariaLabel: 'Preview',
              title: 'Preview'
            },
            {
              icon: <NavForwardIcon />,
              onClick: () => onViewDetails ? onViewDetails(template) : onCardClick(template),
              className: 'explore-grid-card-action-icon--details',
              ariaLabel: 'View Details',
              title: 'View Details'
            }
          ];

          return (
            <ExploreCard
              key={template.isCatalogItem ? template.contentId : `${template.type}-${index}`}
              title={template.title}
              description={template.description}
              language={template.language || language}
              category={template.category}
              getCategoryDisplayName={getCategoryDisplayName}
              icon="language"
              iconSize="large"
              contentType={template.type}
              rightContent={rightContent}
              actions={actions}
              onClick={() => onCardClick(template)}
              className={`${template.isCatalogItem ? 'explore-grid-card--catalog' : 'explore-grid-card--template'} ${isOwned ? 'explore-grid-card--owned' : ''}`}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ExploreGrid;

